import { getInitials } from '@tempo-io/string-util';
import { Avatar, AvatarFallback, AvatarImage } from '@tempo-io/sui-avatar';
import { useOrgMemberByIdQuery } from '@/lib/queries/user-management/useOrgMemberByIdQuery';

interface UserInlineChipProps {
  userId: string;
}

export const UserInlineChip = ({ userId }: UserInlineChipProps) => {
  const { data: user } = useOrgMemberByIdQuery(userId);
  const label = user?.name || user?.email || userId;

  return (
    <span className="flex items-center gap-2 text-sm min-w-0">
      <Avatar size="sm" className="shrink-0">
        <AvatarImage src={user?.pictureUrl} alt={label} />
        <AvatarFallback className="text-xs">{getInitials(label) || '?'}</AvatarFallback>
      </Avatar>
      <span className="truncate">{label}</span>
    </span>
  );
};
